<template>
    <v-card elevation="0">
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="records"
                :loading="getloading"
                show-expand
                single-expand
                :expanded.sync="expanded"
            >
                <template v-slot:top>
                    <v-row align="center" dense>
                        <v-col cols="6">
                            <v-menu v-model="menustart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="ma-2" dense v-model="filterdate" label="Log Date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined hide-details>
                                        <template v-slot:append-outer>
                                            <v-btn color="#977EBE" outlined small @click="callLog" :loading="getloading">Search Log</v-btn>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="filterdate" no-title color="#977EBE" @input="menustart = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <v-card elevation="0" style="position: relative; width: auto;">
                            <v-card-text>
                                <v-simple-table>
                                    <tbody>
                                        <tr>
                                            <th>Recipients (Overriden: {{ item.notificationRecipientsOverridden }})</th>
                                            <td>
                                                <span v-for="r in item.recipients" :key="r">{{ r }} <br /></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Send Result Message</th>
                                            <td>{{ item.sendResult.message }}</td>
                                        </tr>
                                        <tr>
                                            <th>Email Body</th>
                                            <td><span v-html="item.message"></span></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </v-card>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            headers: [
                { text: 'Date', value: 'todayYYYYMMDD', sortable: false },
                { text: 'Type', value: 'postingType'},
                { text: 'Department', value: 'academicDepartment'},
                { text: 'Subject', value: 'subject'},
                { text: 'Send Result', value: 'sendResult.result'},
                { text: 'DateTime Sent', value:'issuedDateTime', sortable: false},
                { text: '', value: 'data-table-expand'},
            ],
            expanded: [],
            menustart: false,
            filterdate: "",
            getloading: false,
            records: [],
        }
    },
    methods: {
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        callLog(){
            const that = this;

            that.getloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getemailnotificationslog&data={"todayYYYYMMDD": "'+that.filterdate+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if(!result.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+result.message, "#EF6C00"); //orange
                    }else {
                        that.records = result.data;
                    }

                    that.getloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.getloading = false;
                })
            //End of API calling
        }
    }
}
</script>